<template>
	<div class="classify">
		<back-to></back-to>
		<!-- 搜索框 -->
		<section class="classifySearch">
			<div class="search-section">
				<div class="search-site" @click="show = true">
					<p>{{cityName}}</p>
					<img src="https://sweetour-pic.obs.myhwclouds.com/sweetmini/index-select.png" alt="">
				</div>
				<div class="search-inp">
					<input type="text" class="weui-search-bar__input" v-model="keyWord" placeholder="景点、关键词、目的地"
						@keyup.13="onSearch" />
					<!--  @input="search" -->
					<img class="search-site-icon" @click="onSearch"
						src="https://sweetour-pic.obs.myhwclouds.com/sweetmini/index-seach.png" alt="">
				</div>
			</div>
		</section>
		<section class="classifyList">
			<List ref="changList" :keyWord="keyWord" :cityId='cityId' :searchShow='true'></List>
		</section>
		<!-- 地址选择 -->
		<van-popup v-model="show" class="addressPopup">
			<!-- 搜索框 -->
			<span class="addressPopups">
				<van-search v-model="cityNameSearch" placeholder="景点、关键词、目的地" background="#f4f4f4" shape="round"
					@search="citySearch" />
			</span>
			<van-cell-group v-for="(item, index) in cityList" :key="index" :title="item.name"
				class="addressPopup-cell-group">
				<van-cell v-for="(map, key) in item.newResponsePlace_Cities" :key="key" :title="map.name"
					@click="onchange(map)" />
			</van-cell-group>
			<div class="addressPopupClose" @click="show = false">
				返回
			</div>
		</van-popup>
	</div>
</template>

<script>
	import List from '@/components/List.vue'
	import BackTo from "@/components/BackTo";
	export default {
		name: 'classify',
		components: {
			List,
			BackTo
		},
		data() {
			return {
				cityId: 0,
				keyWord: '',
				cityName: "全部",
				show: false,
				cityNameSearch: "",
				cityList: []
			}
		},
		mounted() {
			this.$nextTick(() => {
				this.$refs.changList.page = 1
				this.$refs.changList.connect_ProductList()
			});
			this.getAdrress()
		},
		methods: {
			// search(e){
			// 	console.log(e.data)
			// },
			onchange(e) {
				this.cityName = e.name
				this.cityId = e.id
				this.$nextTick(() => {
					this.$refs.changList.page = 1
					this.$refs.changList.connect_ProductList(true)
					this.show = false
				});
			},
			citySearch() {
				this.getAdrress()
			},
			onSearch() {
				this.$nextTick(() => {
					this.$refs.changList.page = 1
					this.$refs.changList.connect_ProductList(true)
				});
			},
			getAdrress() {
				this.$post(
					this.$connectHttpSweet + '/NewNearTravel/NewGetNearTravelPlace?IsControl=true&Name=' + this
					.cityNameSearch, {}
				).then(res => {
					this.cityList = res.result
				})
			}
		}
	}
</script>

<style>
	.classify {
		background-color: #f3f5f4;
	}

	.classifySearch {
		background-color: #fff;
		width: 100%;
		padding: 20px 26px;
		font-size: 0;
		position: fixed;
		top: @nav-bar-height;
		box-sizing: border-box;
		z-index: 999;
	}

	.search-section {
		border: 1px #ff6d00 solid;
		height: 70px;
		border-radius: 36px;
		border-radius: 36px;
		display: flex;
		padding: 0px 36px;
		justify-content: space-between;
		align-items: center;
	}

	.search-site {
		display: flex;
		align-items: center;
	}

	.search-site p {
		display: block;
		max-width: 160px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		padding-right: 8px;
		font-size: 28px;
		color: #333;
	}

	.search-site img {
		width: 14px;
		height: 8px;
	}

	.search-inp {
		width: 100%;
		display: flex;
		align-items: center;
	}

	.search-inp input {
		width: 100%;
		height: 40px;

		font-family: PingFangSC-Semibold, sans-serif;
		font-size: 26px;
		color: #b2b2b2;
		padding-left: 14px;
		border: 0;
		border-left: #eeeeee 1px solid;
		margin-left: 14px;
	}

	.search-site-icon {
		width: 28px;
		height: 28px;
	}

	.classifyList {
		margin-top: 120px;
	}

	.addressPopup {
		width: 100%;
		height: 100vh;
		top: 100px;
		left: 0;
		transform: none;
	}

	.addressPopup .van-cell-group__title {
		background-color: #f4f4f4;
	}

	.addressPopup .van-search__content {
		background-color: #ffffff;
	}

	.addressPopups {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		z-index: 3000;
	}

	.addressPopupClose {
		border-radius: 50%;
		height: 80px;
		line-height: 80px;
		text-align: center;
		width: 80px;
		color: #ffff;
		position: fixed;
		font-size: 26px;
		bottom: 200px;
		right: 30px;
		z-index: 3000;
		background: #ff6d00;
	}
</style>
